/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.createDesignation]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/designation/add', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getDesignation]: ({ commit }, payLoad) => {
    let search
    let url=`/designation/get?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search){
      search = {search:payLoad.search}
      }
      else{
        search = {}
      }
    return httpClient
      .post(
        url,                                                                    
        search,
      ).then(
        (res) => {
          commit(storeMutations.setDesignationMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setDesignationMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getDesignationById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/designation/getById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateDesignationById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/designation/update', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };